import styled from 'styled-components';

export const ChatContainer = styled.div`
  padding-inline: var(--spacement-medium);
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column-reverse;
  gap: var(--spacement-default);
  overflow: auto;
  margin-bottom: var(--spacement-default);
`
